import {
  createListAllQuery,
  graphqlCall,
  listLogEvents,
  ListLogEventsQuery,
  ListLogEventsQueryVariables,
  LogEvent,
  logEventByType,
  LogEventByTypeQuery,
  LogEventByTypeQueryVariables,
  logEventByUser,
  LogEventByUserQuery,
  LogEventByUserQueryVariables,
} from '@akin-home/amplify';

export const listLogEventsQuery = (variables?: ListLogEventsQueryVariables) =>
  graphqlCall<ListLogEventsQuery>(listLogEvents, variables);

export const listLogEventsByType = (variables: LogEventByTypeQueryVariables) =>
  graphqlCall<LogEventByTypeQuery>(logEventByType, variables);

export const listLogEventsByUser = (variables: LogEventByUserQueryVariables) =>
  graphqlCall<LogEventByUserQuery>(logEventByUser, variables);

export const listAllLogEventsByType = createListAllQuery<
  LogEvent,
  LogEventByTypeQueryVariables
>(logEventByType, 'logEventByType');

export const listAllLogEventsByUser = createListAllQuery<
  LogEvent,
  LogEventByUserQueryVariables
>(logEventByUser, 'logEventByUser');